import CustomSelect from "./classes/CustomSelect.js";
import filters from "./components/filters.js";
import data from "./components/data.js";
document.addEventListener("DOMContentLoaded", function(){
    filters(CustomSelect);
    data();
});
